const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg72(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2465,-3318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_7_2",
    transform: "matrix(1,0,0,1,2465.88,3318.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(66,66,66)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2466.24,-2193.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3091.51,2466.62C3073.83,2459.32 3062.29,2442.08 3062.29,2422.96C3062.29,2422.96 3062.29,2422.96 3062.29,2422.96C3062.29,2420.39 3061.27,2417.93 3059.46,2416.11C3057.64,2414.29 3055.18,2413.27 3052.61,2413.27C3022.94,2413.27 2933.53,2413.27 2903.87,2413.27C2898.52,2413.27 2894.18,2417.61 2894.18,2422.96C2894.18,2422.96 2894.18,2422.96 2894.18,2422.96C2894.18,2442.06 2882.71,2459.3 2865.09,2466.67C2831.67,2480.64 2781.26,2512.27 2780.22,2576.13L2780.22,3041.66C2780.22,3058.06 2791.33,3072.38 2807.22,3076.46C2833.88,3082.64 2884.66,3089.72 2977.88,3089.72C3071.47,3089.72 3122.47,3082.61 3149.22,3076.37C3165.1,3072.3 3176.2,3058 3176.2,3041.61C3176.25,2940.87 3176.25,2576.13 3176.25,2576.13C3177.04,2512.42 3125.53,2480.64 3091.51,2466.62Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2471.78,-2196.62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3092.08,2336.99C3092.08,2329.88 3086.32,2324.11 3079.21,2324.11L2888.36,2324.11C2881.26,2324.11 2875.49,2329.88 2875.49,2336.99L2875.49,2362.73C2875.49,2369.83 2881.26,2375.6 2888.36,2375.6L3079.21,2375.6C3086.32,2375.6 3092.08,2369.83 3092.08,2362.73L3092.08,2336.99Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(794.461,0,0,427.444,355.526,816.107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.094,-0.125L0.101,-0.935L0.206,-0.935L0.198,-0.3L0.345,-0.3L0.34,-0.125L0.094,-0.125Z",
    style: {
      fill: "rgb(66,66,66)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72);
export default __webpack_public_path__ + "static/media/7_2.fba93fdeb0fb5fa45948a72bbb5f1664.svg";
export { ForwardRef as ReactComponent };